import './bg-svg-wrp.scss';
import { gsap } from 'gsap';

class BgImageWrp {
  constructor() {
    this.DOM = {}
    this.DOM.svgImges = [...document.querySelectorAll('.bg-svg-wrp .svg-wrapper img.rot-in')]
    this.fireOnce = true;
    console.log(this.DOM);
    this.observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          gsap.from(entry.target, {
            scale: .7,
            rotate: '-15deg',
            duration: 1.25,
          })
          if (this.fireOnce) this.observer.unobserve(entry.target)
        }
      });
    }, {});
    this.init()

  }
  init() {
    this.initObervation()
  }
  initObervation() {
    this.DOM.svgImges.forEach(elem => this.observer.observe(elem))
  }


}
new BgImageWrp()